import { useDispatch, useSelector } from 'react-redux'
import { selectHomeData, selectIsEditingSpeedFormation } from '@/containers/HomePage/HomeSelectors'
import { setIsEditingSpeedFormation, setSpeedFormationDate } from '@/containers/HomePage/HomeSlice'

const useSpeedFormation = () => {
  const dispatch = useDispatch()
  const { speedFormation, isAdmin } = useSelector(selectHomeData)
  const isEditing = useSelector(selectIsEditingSpeedFormation)

  const setIsEditing = value => {
    if (value) {
      dispatch(setSpeedFormationDate(speedFormation?.date ?? null))
    }
    dispatch(setIsEditingSpeedFormation(value))
  }

  return { speedFormation, isAdmin, isEditing, setIsEditing }
}

export default useSpeedFormation
